import { getWindowsHeight } from './generic';

const BS_MODAL_FOCUS_RELEASE_FLAG = 'bsModalFocusReleaseBound';

// prepocita rozmery backdrop elementu (pri zmene velikosti okna modalu)
export const modalBackdropResize = (): void => {
    const windowHeight = getWindowsHeight();
    const modalElements = document.getElementsByClassName('modal-dialog');
    if (modalElements[0]) {
        const modalHeight = modalElements[0].clientHeight + 60;
        const height = windowHeight > modalHeight ? windowHeight : modalHeight;
        const backdropEls = document.getElementsByClassName('modal-backdrop');
        if (backdropEls[0]) {
            (backdropEls[0] as HTMLDivElement).style.height = `${height}px`;
        }
    }
};

/**
 * Bootstrap 5 při zavírání modalu nastaví `aria-hidden="true"` dřív, než odejde fokus
 * z prvku uvnitř (typicky tlačítko „Zavřít“ / `.btn-close`). Chromium pak hlásí:
 * „Blocked aria-hidden on an element because its descendant retained focus.“
 *
 * Proto před skrytím uvolníme fokus, modal označíme `inert` (doporučení WAI-ARIA /
 * Bootstrap #41005) a u dismiss tlačítek zabráníme převzetí fokusu myší (`mousedown`).
 * Volat jednou při startu stránky — platí pro všechny `.modal` (Contact Us, FormMaker, …).
 */
export const initBootstrapModalFocusRelease = (): void => {
    if (document.documentElement.dataset[BS_MODAL_FOCUS_RELEASE_FLAG] === '1') {
        return;
    }
    document.documentElement.dataset[BS_MODAL_FOCUS_RELEASE_FLAG] = '1';

    document.addEventListener('hide.bs.modal', (event: Event): void => {
        const modalEl = event.target;
        if (!(modalEl instanceof HTMLElement) || !modalEl.classList.contains('modal')) {
            return;
        }

        const active = document.activeElement;
        if (active instanceof HTMLElement && modalEl.contains(active)) {
            active.blur();
        }

        // inert zabrání, aby fokus zůstal uvnitř skrytého modalu (náhrada / doplněk aria-hidden)
        modalEl.setAttribute('inert', '');
    });

    document.addEventListener('show.bs.modal', (event: Event): void => {
        const modalEl = event.target;
        if (!(modalEl instanceof HTMLElement) || !modalEl.classList.contains('modal')) {
            return;
        }
        modalEl.removeAttribute('inert');
    });

    // Myší klik na dismiss: jinak by tlačítko získalo fokus těsně před aria-hidden.
    document.addEventListener(
        'mousedown',
        (event: MouseEvent): void => {
            if (event.button !== 0) {
                return;
            }
            const target = event.target;
            if (!(target instanceof Element)) {
                return;
            }
            const dismissBtn = target.closest('[data-bs-dismiss="modal"]');
            if (!(dismissBtn instanceof HTMLElement) || !dismissBtn.closest('.modal')) {
                return;
            }
            event.preventDefault();
        },
        true,
    );
};
